<template>
  <div>
    <main-header />
    <iframe
      class="users-v2-iframe"
      :src="usersV2Url"
      title="Manage Users V2"
      frameborder="0" />
  </div>
</template>

<script lang="ts">
import config from '@/config'

export default {
  computed: {
    usersV2Url () {
      const base = (config.get_FRONTEND_V2_URL() || '').replace(/\/+$/, '')
      const token = this.$store.state.auth.token
      return `${base}/#/users-window?token=${encodeURIComponent(token)}`
    }
  }
}
</script>

<style>
.users-v2-iframe {
  width: 100%;
  height: calc(100vh - 60px);
  border: 0;
  display: block;
}
</style>
